interface PitCategory {
    name: string;
    label: string;
    tags: Record<string, string>;
}

interface PitOption {
    id: string;
    label: string;
}

/**
 * All the PIT categories, please do not change the names of the categories and/or tags without updating
 * the PIT project.
 *
 * Any commented-out tag are only there for reference, and will be removed somewhere along the way.
 */
const pitCategories: PitCategory[] = [
    {
        name: 'project_info',
        label: 'Projectgegevens',
        tags: {
            // units: 'Wooneenheden (aantal)',
            // costs: 'Schatting bouwkosten',
            // space: 'Commerciële ruimte (m2)',
            // bvo: 'BVO (m2)',
            // bvo_price: 'Prijs per BVO',
            //work_type_one: 'Werksoort I',
            //work_type_two: 'Werksoort II',
            // function: 'Gebruiksfunctie (hoofd)',
            // sub_function: 'Sub-gebruiksfunctie',
            height_above: 'Hoogte gebouw',
            height_under: 'Bouwlagen onder maaiveld'
        }
    },
    {
        name: 'client',
        label: 'Opdrachtgever / Afnemer / Ontwikkelaar',
        tags: {
            //client: 'Opdrachtgever',
            client_type: 'Type opdrachtgever',
            // owner: 'Ontwikkelaar',
            //design_owner: 'Ontwerpverantwoordelijkheid',
            acquisition_type: 'Wijze van verwerving',
            credit_score: 'Kredietscore',
            // alt_client: 'Afnemer indien anders',
            // from: 'Vanaf'
        }
    },
    //{
    //    name: 'system',
    //    label: 'Bouwsysteem / Grondslag',
    //    tags: {
    //        method: 'Bouwmethodiek',
    //        comments: 'Bijzonderheden'
    //    }
    //},
    {
        name: 'financial',
        label: 'Financieel & Contract',
        tags: {
            contract_scope: 'Contractscope',
            realisation_form: 'Algemene voorwaarden',
            // requirements: 'Randvoorwaarden',
            criteria: 'Gunningcriteria (EMV)',
            // tender_date: 'Aanbiedingsdatum',
            // tender_costs: 'Tenderkosten (schatting)',
            // external_financing: 'Externe financiering',
            // pre_financing: 'Liquiditeit/Voorfinanciering'
        }
    },
    {
        name: 'mandate',
        label: 'Mandatering',
        tags: {
            construction_costs: 'Aanneemsom',
        }
    },
    {
        name: 'planning',
        label: 'Planning / Bouwtijd',
        tags: {
            // start_date: 'Startdatum werk',
            // end_date: 'Einddatum werk',
            // project_duration: 'Duur project (in maanden)',
            // number_of_phases: 'Aantal fasen uitvoering',
            // status_environment_permit: 'Status omgevingsvergunning',
            // nuts_capacity_problem: 'Nutsvoorzieningen capaciteitenprobleem',
            // natura_2000_area: 'Natura 2000 gebied',
            // nitrogen_complicity: 'Voldoet aan aerius-berekening stikstof'
        }
    },
    //{
    //    name: 'team',
    //    label: 'Bouwteam',
    //    tags: {
    //        required_cooperation: 'Beoogde samenwerking',
    //        legal_form: 'Rechtsvorm'
    //        parties: 'Welke partij(en)'
    //    }
    //},
    //{
    //    name: 'design_team',
    //    label: 'Ontwerpende partij',
    //    tags: {
    //        architect: 'Architect',
    //        constructor: 'Constructeur',
    //        advisor: 'Adviseur',
    //        second_advisor: 'Second opinion adviseur'
    //    }
    //}
];

export class PitOptions {
    private pitSelectOptions: PitOption[] = [];
    private static _instance: PitOptions;

    public static getInstance(): PitOptions {
        if (!this._instance) {
            this._instance = new PitOptions();
        }
        return this._instance;
    }

    public getOptions(): PitOption[] {
        if (this.pitSelectOptions?.length === 0) {
            const options: PitOption[] = [];
            pitCategories.map(category => {
                Object.entries(category.tags).forEach(entry => {
                    options.push({
                        id: `${category.name}.${entry[0]}`,
                        label: `${category.label} - ${entry[1]}`
                    });
                });
            });
            this.pitSelectOptions.push(...options.sort((one, two) => one.label.localeCompare(two.label)));
        }
        return this.pitSelectOptions;
    }
}
